import React from 'react';
import {
  Switch,
  Route,
  match,
} from 'react-router-dom';

import Home from './Public/Home';
import ArticleDetail from './Public/ArticleDetail';
import SideBar from './Components/Sidebar';
import Header from './Public/Header';

type TParams = {
};

interface PublicProps {
  match: match<TParams>;
}

function Public({match}: PublicProps) {
  const {path} = match;
  return (
    <React.Fragment>
      <Header />
      <div className="main-content-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8">
              <Switch>
                <Route exact path={`${path}/`}
                  render={() => <Home />}
                />
                <Route path={`${path}/category/:id`}
                  render={props =>
                    <Home key={props.match.params.id}
                      category={props.match.params.id} {...props}
                    />
                  }
                />
                <Route path={`${path}/author/:id`}
                  render={props =>
                    <Home key={props.match.params.id}
                      author={props.match.params.id} {...props}
                    />
                  }
                />
                <Route path={`${path}/search/:terms`}
                  render={props =>
                    <Home key={props.match.params.terms}
                      search={props.match.params.terms} {...props}
                    />
                  }
                />
                <Route path={`${path}/article/:id`}
                  render={props =>
                    <ArticleDetail key={props.match.params.id}
                      {...props}
                    />
                  }
                />
              </Switch>
            </div>
            <SideBar />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Public;
